const entities = {
  addRegion: 'addRegion',
  event: 'event',
  category: 'category',
  parent_product: 'parent_product',
  child_product: 'child_product',
  color: 'color',
  inventory: 'inventory',
  region: 'region',
  retailer: 'retailer',
  size: 'size',
  plan: 'plan',
  location: 'location',
};

export const API_V4_ENTITIES = [entities.location, entities.retailer];

export default entities;
